import { axiosGetAuthorize, axiosPostAuthorize } from '../AxiosRequests';
import { GetMembershipCorporateList, ActiveInActiveMembershipCorporate, GetAllCorporateStatus, DeleteMembershipCorporate, GetAllDropdownsForMemberManagement, GetMembersList, AddNewMember, UpdateMemberDetails, GetMemberById, DeleteMember } from '../ApiEndPoints'

export default class MembershipCorporateServices {

    async getMembershipCorporateList(request) {
        return axiosPostAuthorize(GetMembershipCorporateList, request)
    }

    async getMembershipCorporateList(request) {
        return axiosPostAuthorize(GetMembershipCorporateList, request)
    }

    async activeInActiveCorporateMember(request) {
        return axiosPostAuthorize(ActiveInActiveMembershipCorporate, request)
    }

    async deleteCorporateMember(request) {
        return axiosPostAuthorize(DeleteMembershipCorporate, request)
    }

    async getAllCorporateStatus() {
        return axiosGetAuthorize(GetAllCorporateStatus);
    }

    async getAllDropdownsForMemberManagement() {
        return axiosGetAuthorize(GetAllDropdownsForMemberManagement);
    }

    async getMembersList(request) {
        return axiosPostAuthorize(GetMembersList, request)
    }
    async addNewMember(request) {
        return axiosPostAuthorize(AddNewMember, request)
    }

    async updateMemberDetails(request) {
        return axiosPostAuthorize(UpdateMemberDetails, request)
    }

    async getMemberById(request) {
        return axiosGetAuthorize(GetMemberById, request);
    }
    async deleteMember(request) {
        return axiosPostAuthorize(DeleteMember, request)
    }

}
